import React, { Component } from "react"

/* REST API */
import { history } from "../api/History"

/* Constants */
import { env, utils } from "../constants"

/* Icons */
import { CaretDownOutlined, LoadingOutlined } from "@ant-design/icons"

/* Moment */
import moment from "moment"
import "moment/locale/ru"
moment.locale("ru")

/* Fields */
const pathname = window.location.search
const token = pathname.length > 1 ? pathname.substring(1) : ""
const SCORE = { "14": 1, "2": 2, "3": 3, "4": 4, "5": 5, "6": 6, "7": 7, "8": 8, "9": 9, "10": 0, "11": 0, "12": 0, "13": 0 }
const PAGE_SIZE = 10


/* Widget History */
class History extends Component {

    constructor() {
        super()

        this.state = {
            status: "",
            data: [],
            page: 1,
            hasMore: false,
            active: -1
        }
    }

    componentDidMount() {

        /* Fields */
        const { mobileVisible } = this.props

        /* Load */
        if (mobileVisible) {
            this.load()
        }
    }

    componentDidUpdate = (prevProps) => {

        /* Fields */
        const { visible } = this.props

        /* DESKTOP */
        if (visible !== prevProps.visible) {
            if (visible) this.load()
            else this.reset()
        }

    }

    /* Reset */
    reset = () => {
        this.setState({ status: "", data: [], page: 1, hasMore: false, active: -1 })
    }

    /* Load Action */
    load = (page = 1, reload = true) => {

        /* Fields */
        const { data } = this.state

        /* Reload */
        if (reload) {
            this.setState({ status: "loading" })
        }

        /* Start Loading */
        this.setState({ page })

        /* Send to REST API */
        history(token, page).then(response => {
            if (response.status === 200) {

                const nextChunk = Array.isArray(response.data) ? response.data : []
                const list = page > 1 ? [...data, ...nextChunk] : nextChunk
                const hasMore = nextChunk.length === PAGE_SIZE

                this.setState({ data: list, status: "ok", hasMore })
            }
        }).catch(() => {
            this.setState({ data: [], status: "loading" })
        })

    }

    /* Load More */
    loadMore = () => {

        /* Fields */
        const { page, hasMore, status } = this.state

        if (!hasMore) return
        if (status === "loading") return

        this.load(page + 1, false)
    }

    /* Determine and draw total */
    _total = data => {

        /* Fields */
        const transactions = Array.isArray(data.transactions) ? data.transactions : []
        let total = 0
        let currency = "USD"

        transactions.forEach(({ type, total: amount, currency: _currency }) => {
            const value = parseFloat(amount) || 0
            total += type === "credit" ? value : type === "debit" ? -value : 0
            currency = _currency || currency
        })

        const sign = total > 0 ? "+ " : total < 0 ? "- " : ""

        return <div className="history-head-total">{sign}{utils.convertor(Math.abs(total), currency)}</div>
    }


    /* Draw time */
    _time = data => {

        if (!data.createdAt) return null

        const m = moment(data.createdAt)
        const now = moment()

        const text =
            m.isSame(now, "day") ? "Сегодня" :
                m.isSame(now.clone().subtract(1, "day"), "day") ? "Вчера" :
                    m.format("YYYY-MM-DD")

        return (
            <div className="history-head-datetime">
                <div className="history-head-time">{m.format("HH:mm")}</div>
                <div className="history-head-date">{text}</div>
            </div>
        )
    }

    /* Draw Dealer */
    _dealer = data => {

        /* Check Data */
        if (data) {
            return <div className="history-dealer">Дилер: {data}</div>
        }

    }

    /* Draw End Reason */
    _endReason = data => {

        /* Check Data */
        if (data) {
            return <div className="history-reason-error">{data}</div>
        }

    }

    /* Draw Balance */
    _balance = data => {

        /* Check Transactions */
        if (data.startBalance && data.transactions && Array.isArray(data.transactions) && data.transactions.length > 0) {

            let endBalance = parseFloat(data.startBalance)
            let currency = "USD"

            /* Calculate Balance */
            data.transactions.forEach(transaction => {
                if (transaction.type === "credit") {
                    endBalance = endBalance + parseFloat(transaction.total)
                }
                if (transaction.type === "debit") {
                    endBalance = endBalance - parseFloat(transaction.total)
                }
                currency = transaction.currency
            })

            return (
                <div className="history-transactions">
                    <div className="history-transaction-balance">Баланс до игры: {utils.convertor(data.startBalance, currency)}</div>
                    <div className="history-transaction-balance">Баланс после игры: {utils.convertor(endBalance, currency)}</div>
                </div>
            )
        }
    }


    /* Processes */
    _process = (data = []) => {

        const { currency } = this.props

        /* Check Data */
        if (data && Array.isArray(data) && data.length > 0) {

            let total = 0
            let totalWin = 0

            data.forEach(item => {
                if (item.total) {
                    total += parseFloat(item.total)
                }
                if (item.win) {
                    totalWin += parseFloat(item.win)
                }
            })

            return (
                <div className="history-transactions">
                    <table className="operations-table">
                        <thead>
                            <tr>
                                <th>Вид ставки</th>
                                <th>Cтавка</th>
                                <th>Выплата</th>
                            </tr>
                        </thead>
                        <tbody>
                            {data.map((item, index) =>
                                <tr key={`${index}`} className="item">
                                    <td>{item.reason}</td>
                                    <td>{utils.convertor(item.total, currency)}</td>
                                    <td>{utils.convertor(item.win || 0, currency)}</td>
                                </tr>
                            )}
                            <tr>
                                <td>Итого</td>
                                <td>{utils.convertor(total, currency)}</td>
                                <td>{utils.convertor(totalWin, currency)}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            )
        }
    }

    /* Get Cards */
    getCards = (cards = [], type) => {
        return cards.filter(c => c.type === type).sort((a, b) => a.id - b.id)
    }

    /* Draw Cards */
    _cards = data => {

        /* Check Data */
        if (!data) {
            return
        }

        /* Get Total */
        const getTotal = cards => {
            let total = 0
            for (const c of cards) total += SCORE[String(c?.value)] ?? 0
            return total % 10
        }

        /* Get Cards */
        const playerCards = this.getCards(data.cards, "player")
        const bankerCards = this.getCards(data.cards, "banker")

        return (
            <div className="mpb--history-result">

                <div className={`mpb--history-result-win ${utils.check(data.win, "")}`}>{utils.check(data.win, "")}</div>

                <div className="mpb--history-containers">

                    <div className="mpb--history-container mpb--player-history-container">

                        <div className="mpb--history-container-head">
                            <div className="mpb--history-container-title">PLAYER</div>
                            <div className="mpb--history-container-score">{getTotal(playerCards)}</div>
                        </div>

                        <div className="mpb--history-cards">
                            {playerCards.map((item, index) =>
                                <img src={`${env.mediapoint}/cards/${item.image}`} alt="Card" key={`${index}`} />
                            )}
                        </div>

                    </div>

                    <div className="mpb--history-container">

                        <div className="mpb--history-container-head">
                            <div className="mpb--history-container-title">BANKER</div>
                            <div className="mpb--history-container-score">{getTotal(bankerCards)}</div>
                        </div>

                        <div className="mpb--history-cards">
                            {bankerCards.map((item, index) =>
                                <img src={`${env.mediapoint}/cards/${item.image}`} alt="Card" key={`${index}`} />
                            )}
                        </div>

                    </div>

                </div>

            </div>
        )

    }

    /* Draw Content */
    _content = () => {

        /* Fields */
        const { status, active, data, hasMore } = this.state

        /* Loading Case */
        if (status === "loading") {
            return (
                <div className="modal-body-loading">
                    <LoadingOutlined />
                </div>
            )
        }

        return (
            <div className="modal-body">
                {data.map((item, index) =>
                    <div className={`history-item ${index === active ? "history-item-active" : "default"}`} key={`${index}`}>

                        {/* Draw history head */}
                        <div onClick={() => this.setState({ active: active === index ? -1 : index })} className={`history-head ${index === active ? "history-active-head" : "default"}`}>
                            <div className="history-number">Игра #{item.number}</div>
                            <div className="history-head-right">
                                {this._total(item)}
                                {this._time(item)}
                                <CaretDownOutlined />
                            </div>
                        </div>

                        <div className={`history-hidden-box ${index === active ? "history-hidden-box-active" : ""}`}>
                            {this._dealer(item.dealer)}
                            {this._endReason(item.endReason)}
                            {this._balance(item)}
                            {this._process(item.processes)}
                            {this._cards(item)}
                        </div>

                    </div>
                )}


                {hasMore &&
                    <div className={`modal-bottom ${data.length > 10 ? "initial" : "default"}`}>
                        <div className="modal-load-more" onClick={() => this.loadMore()}>Загрузить еще</div>
                    </div>
                }

                <div className="modal-bottom-space" />
            </div>
        )

    }


    render = () => {

        /* Props and state */
        const { visible, close, always } = this.props

        return (
            <div className={`modal history ${always} ${visible ? "animated" : "default"}`}>
                <div className="modal-content">

                    {/* Modal Header */}
                    <div className="modal-header">
                        История игры
                        <div onClick={() => close()} className="modal-close">
                            <img src={`${env.mediapoint}/images/x.png`} alt="CLOSE" />
                        </div>
                    </div>

                    {/* Draw Content */}
                    {this._content()}

                </div>
            </div>
        )
    }
}

export default History